import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectJobServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedProjectJobActions } from './paginated-project-job.actions';

export const paginatedProjectJobFeatureKey = 'paginatedProjectJob';

export interface PaginatedProjectJobState {
  items: ProjectJobServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
}

export const initialState: PaginatedProjectJobState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedProjectJobActions.listPaginatedProjectJobs,
    (state): PaginatedProjectJobState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedProjectJobActions.listPaginatedProjectJobsSuccess,
    (state, { data }): PaginatedProjectJobState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedProjectJobActions.listPaginatedProjectJobsFailure,
    (state, { error }): PaginatedProjectJobState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);

export const paginatedProjectJobFeature = createFeature({
  name: paginatedProjectJobFeatureKey,
  reducer,
});
